import compact from "lodash/compact";
import { documentObjectIconMap } from "Common/dictionaries/documentObjectIconId";
import SendToGraphDataType from "Areas/Documents/content/types/sendToGraphDataType";
import locale from "./buildContextMenuItems.locale";
const iconType = {
    [SendToGraphDataType.PHOTO]: "SL Image",
    [SendToGraphDataType.TEXT]: "SL Phrase 2"
};
export default (selectedData, onSendPhotoToGraph, onSentTextToGraph) => {
    if (!(selectedData === null || selectedData === void 0 ? void 0 : selectedData.data.length))
        return undefined;
    const sendToGraphCbByType = {
        [SendToGraphDataType.PHOTO]: onSendPhotoToGraph,
        [SendToGraphDataType.TEXT]: onSentTextToGraph
    };
    const cb = sendToGraphCbByType[selectedData.type];
    const items = compact([
        cb && {
            iconSrc: documentObjectIconMap[iconType[selectedData.type]],
            text: locale.SEND_TO_GRAPH,
            onClick: () => cb(selectedData.data)
        }
    ]);
    return items;
};
